import React from 'react';

import styles from './ExitButton.module.scss';


const ExitButton = (props) => {
  const classes = [styles.ExitButton, props.className];

  return (
    <div className={classes.join(' ')} onClick={props.onClick}/>
  );
}

export default ExitButton;
